/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2023-03-24 15:45:27
 * @LastEditors  : your name
 * @LastEditTime : 2023-07-10 11:11:58
 * @Description  : 上传文件
 */

import { ref } from "vue";
import request from '@/utils/request.js'
import { os } from '@/utils/index'
export default function useUpload(){
    let accessid = '',
    host = '',
    policyBase64 = '',
    signature = '',
    callbackbody = '',
    key = '',   // 需要
    expire = 0,
    g_object_name = '', // 文件名字
    now  = Date.parse(new Date()) / 1000

    let dyShareOver = ref(false)
    let isFile = ref(true)
    let dyShareMsg = ref('')
    let shareData = {}
    let percentage = ref(0)
    let dyopenurl = ''
    let uploadList = {}
    let extensions = os() == 1 ? 'mov': 'mp4'

    const send_request = ()=> {
        var xmlhttp = null;
        if (window.XMLHttpRequest) {
            xmlhttp=new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        }
    
        if (xmlhttp!=null) {
            // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
            let serverUrl = '/api/v1/upload/sign' // https://video2.cps24.dzods.cn
            
            xmlhttp.open( "GET", serverUrl, false );
            xmlhttp.send( null );
            return xmlhttp.responseText
        } else {
            alert("Your browser does not support XMLHTTP.");
        }
    }

    const get_signature=() =>{
        // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
        now = Date.parse(new Date()) / 1000; 
        if (expire < now + 3) {
            let body = send_request()
            var obj = eval ("(" + body + ")");
            host = obj['host']
            policyBase64 = obj['policy']
            accessid = obj['accessid']
            signature = obj['signature']
            expire = parseInt(obj['expire'])
            callbackbody = obj['callback'] 
            key = obj['dir']
            return true;
        }
        return false;
    }

    const random_string = (len) => {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';   
        var maxPos = chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    const get_suffix = (filename) =>{
        let pos = filename.lastIndexOf('.'), suffix = ''
        if (pos != -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    }

    const set_upload_param = (up, filename, ret) =>{
        if (ret == false){
            ret = get_signature()
        }
        g_object_name = key;
        if (filename != '') { 
            let suffix = get_suffix(filename)
            g_object_name = key + random_string(10) + suffix
        }
        let new_multipart_params = {
            'key' : g_object_name,
            'policy': policyBase64,
            'OSSAccessKeyId': accessid, 
            'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
            'callback' : callbackbody,
            'signature': signature,
        };

        up.setOption({
            'url': host,
            'multipart_params': new_multipart_params
        });
        up.start();
    }

    // 导出之后new 一个上传对象并调用init方法
    const initUpload = ()=> {
        percentage.value = 0
        let uploader = new window.plupload.Uploader({
            runtimes : 'html5,flash,silverlight,html4',
            browse_button : 'selectfiles', 
            multi_selection: false,
            container: document.getElementById('container'),
            // flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
            // silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
            url : 'http://oss.aliyuncs.com',

            filters: {
                mime_types : [ //只允许上传图片和zip文件
                { title : "mv files", extensions, multiple: 1 }, 
                ],
                max_file_size : '100mb', //最大只能上传10mb的文件
                prevent_duplicates : true //不允许选取重复文件
            },

            init: {
                // 对象初始化
                PostInit: function() {
                    dyShareOver.value = false
                    isFile.value = true
                },

                FilesAdded: function(up, files) {
                    window.plupload.each(files, function(file) {
                        document.getElementById('ossfile').innerHTML = '<div id="' + file.id + '">'+ ' 大小：' + plupload.formatSize(file.size) + '<b></b>'
                    });
                    dyShareOver.value = false
                    isFile.value = false
                    dyShareMsg.value ='上传中...'
                    set_upload_param(uploader, '', false);

                },

                BeforeUpload: function(up, file) {
                    set_upload_param(up, file.name, true);
                },

                UploadProgress: function(up, file) {
                    var d = document.getElementById(file.id);
                    d.getElementsByTagName('b')[0].innerHTML = '&nbsp;&nbsp;进度：<span>' + file.percent + "%</span>";
                    percentage.value = file.percent-0
                    if(file.percent == 100) {
                        dyShareMsg.value ='上传成功,开始准备数据...'
                    }
                    // var prog = d.getElementsByTagName('div')[0];
                    // var progBar = prog.getElementsByTagName('div')[0]
                    // progBar.style.width= 2*file.percent+'px';
                    // progBar.setAttribute('aria-valuenow', file.percent);
                },

                FileUploaded: function(up, file, info) {
                    if (info.status == 200 || info.status == 203) {
                        request.post('/v1/upload/getLink', {file: g_object_name}).then(res=>{
                            if(res) {
                                shareData.video_path = encodeURIComponent(res)
                                dyShareOver.value = false
                                getSignDy(shareData)
                                uploadList[file.name] = encodeURIComponent(res)
                            }
                        }).catch(()=>{
                            dyShareOver.value = true
                            isFile.value = true
                            dyShareMsg.value ='数据准备失败,可点击按钮关闭...'
                        })
                        // document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = 'upload to oss success, object name:' + g_object_name + ' 回调服务器返回的内容是:' + info.response;
                    } else {
                        dyShareOver.value = true
                        isFile.value = true
                        dyShareMsg.value ='数据准备失败,可点击按钮关闭...'
                    } 
                },

                Error: function(up, err) {
                    if (err.code == -600) {
                        dyShareMsg.value ='上传文件失败，太大了最大100M！'
                        // document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"));
                    }else if (err.code == -601) {
                        dyShareMsg.value ='上传文件失败，选择的文件后缀不对！'
                    }else if (err.code == -602) {
                        dyShareMsg.value ='当前文件已存在可直接挂载！'
                        shareData.video_path = uploadList[err.file.name]
                        console.log('baocun', err.file.name, uploadList)
                    }else {
                        dyShareMsg.value =`上传文件失败！${err.response}`
                    }
                    dyShareOver.value = true
                    isFile.value = true
                }
            }
        })
        uploader.init()
    }

    /**
     * @description: 上传视频
     * @param {*} file
     * @param {*} query
     * @return {*}
     */    
     const startShare = (query)=>{
        dyShareOver.value = false
        // 分享参数
        let startData = {share_type: 'h5',state: query.referralId, share_to_publish: 1 ,micro_app_info: ''}
        let miapp = {
            appId: query.appid,
            appTitle: query.name,
            description: query.bookName,
            appUrl: query.path
        }
        let micro_app_info = JSON.stringify(miapp)
        startData.micro_app_info = encodeURIComponent(micro_app_info)
        shareData = startData
        isFile.value = true
        
    }

    /**
     * @description: 获取签名，拼接拉起url
     * @param {*} shareData
     * @return {*}
     */
    const getSignDy = (shareData) => {
        request.post('/v1/koc/getdyh5sign', {}).then(res=>{
            if(res) {
                shareData.timestamp = res.timestamp
                shareData.nonce_str = res.nonce_str
                shareData.signature = res.signature
                shareData.client_key = res.client_key
                // 拼接参数拉起参数
                dyopenurl ='snssdk1128://openplatform/share' +  Object.entries(shareData).reduce((t, v) => `${t}${v[0]}=${v[1]}&`,
                    Object.keys(shareData).length ? "?" : ""
                ).replace(/&$/, "");
                dyShareOver.value = true
                isFile.value = true
                dyShareMsg.value ='数据准备完成，可点击挂载'
                // openDyUrl()
            }
        }).catch(()=>{
            dyShareOver.value = true
            dyShareMsg.value ='数据准备失败,可点击按钮关闭...'
        })
    }
    
    /**
     * @description: 执行拉起操作
     * @return {*}
     */    
    const openDyUrl = (falg) => {
        if(!dyShareOver.value) return false
        if(dyopenurl && falg != 'close') {
            window.location.href = dyopenurl
        }
        dyShareMsg.value = ''
        percentage.value = 0
        document.getElementById('ossfile').innerHTML=""
    }

    return {dyShareOver, isFile, dyShareMsg, percentage, initUpload, startShare , openDyUrl }
}
